import { Loader2 } from "lucide-react";

export const PageHeader = ({ eyebrow, title, desc, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 rise">
    <div>
      {eyebrow && <div className="eyebrow mb-1.5">{eyebrow}</div>}
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
      {desc && <p className="text-sm text-zinc-400 mt-1.5 max-w-2xl">{desc}</p>}
    </div>
    {action}
  </div>
);

export const StatCard = ({ label, value, icon: Icon, hint, testid, delay = 1 }) => (
  <div className={`card-lux p-4 sm:p-5 rise rise-${delay}`} data-testid={testid}>
    <div className="flex items-center justify-between mb-3">
      <span className="text-xs text-zinc-400 font-medium">{label}</span>
      {Icon && <span className="h-8 w-8 rounded-lg bg-amber-500/10 border border-amber-500/20 grid place-items-center"><Icon className="h-4 w-4 text-amber-400" /></span>}
    </div>
    <div className="font-display text-2xl sm:text-3xl font-extrabold text-white">{value}</div>
    {hint && <div className="text-[11px] text-zinc-500 mt-1">{hint}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, desc, action, testid = "empty-state" }) => (
  <div className="card-lux border-dashed p-10 text-center flex flex-col items-center gap-3" data-testid={testid}>
    {Icon && <div className="h-12 w-12 rounded-2xl bg-amber-500/10 grid place-items-center"><Icon className="h-6 w-6 text-amber-400" /></div>}
    <div className="font-display text-lg font-bold">{title}</div>
    {desc && <p className="text-sm text-zinc-400 max-w-sm">{desc}</p>}
    {action}
  </div>
);

export const Spinner = () => (
  <div className="flex justify-center py-16" data-testid="loading-spinner"><Loader2 className="h-6 w-6 animate-spin text-amber-400" /></div>
);

export const EthicsNote = ({ children }) => (
  <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/5 px-4 py-3 text-xs text-emerald-200/90" data-testid="ethics-note">
    {children}
  </div>
);
